const co2_mean = [
315.365,
315.44416666666666,
315.4666666666667,
315.5316666666667,
315.6075,
315.66416666666663,
315.65333333333336,
315.70666666666665,
315.7816666666667,
315.90500000000003,
315.98083333333335,
316.0516666666667,
316.0933333333333,
316.1708333333333,
316.28,
316.4258333333333,
316.54583333333335,
316.6825,
316.77416666666664,
316.8016666666667,
316.8433333333333,
316.8591666666667,
316.91,
316.9483333333333,
317.00833333333327,
317.0883333333333,
317.12583333333333,
317.1708333333333,
317.1858333333333,
317.2183333333333,
317.2925,
317.36083333333335,
317.4841666666667,
317.5758333333333,
317.64416666666665,
317.7316666666667,
317.80249999999995,
317.8975,
317.98833333333334,
318.02500000000003,
318.09583333333336,
318.1825,
318.23333333333335,
318.33833333333337,
318.3475,
318.3966666666667,
318.4541666666667,
318.5208333333333,
318.56416666666667,
318.57916666666665,
318.6466666666667,
318.7491666666667,
318.8208333333334,
318.8316666666667,
318.8625,
318.8591666666667,
318.9066666666667,
318.9383333333334,
318.9925,
319.06166666666667,
319.14000000000004,
319.2133333333333,
319.2516666666667,
319.25250000000005,
319.2866666666667,
319.345,
319.4216666666667,
319.4625,
319.5358333333333,
319.58666666666664,
319.6166666666666,
319.6058333333333,
319.64166666666665,
319.65416666666664,
319.6791666666666,
319.6716666666667,
319.66999999999996,
319.7341666666667,
319.74916666666667,
319.84166666666664,
319.8775,
319.97666666666663,
320.0358333333333,
320.13416666666666,
320.23083333333335,
320.3558333333333,
320.4858333333333,
320.6449999999999,
320.8016666666666,
320.89916666666664,
321.0233333333333,
321.0925,
321.1591666666667,
321.23499999999996,
321.3691666666666,
321.5116666666666,
321.5866666666666,
321.6408333333333,
321.7008333333333,
321.7775,
321.80583333333334,
321.81916666666666,
321.86583333333334,
321.9166666666667,
322.02416666666664,
322.1033333333333,
322.18083333333334,
322.2008333333333,
322.25500000000005,
322.3258333333334,
322.37583333333333,
322.42333333333335,
322.5291666666667,
322.66249999999997,
322.76166666666666,
322.85166666666663,
322.92333333333335,
322.9725,
323.05,
323.1691666666666,
323.27500000000003,
323.42,
323.5566666666667,
323.70750000000004,
323.82,
323.96500000000003,
324.0941666666667,
324.26500000000004,
324.3925,
324.52083333333337,
324.62333333333333,
324.71166666666664,
324.84166666666664,
324.95,
325.07249999999993,
325.1308333333333,
325.2108333333333,
325.24916666666667,
325.335,
325.39500000000004,
325.50166666666667,
325.5975,
325.6816666666667,
325.77416666666664,
325.83250000000004,
325.8525,
325.82416666666666,
325.895,
325.96999999999997,
326.055,
326.1166666666667,
326.1383333333334,
326.18,
326.24583333333334,
326.31916666666666,
326.3691666666667,
326.4483333333334,
326.4966666666667,
326.6575,
326.7525,
326.7958333333334,
326.8525,
326.92666666666673,
327.05,
327.18666666666667,
327.3283333333333,
327.45666666666665,
327.605,
327.7658333333333,
327.97833333333335,
328.1266666666667,
328.32750000000004,
328.5758333333334,
328.81166666666667,
329.06083333333333,
329.2833333333333,
329.4483333333333,
329.58666666666664,
329.67749999999995,
329.7441666666667,
329.84,
329.93833333333333,
330.03416666666664,
330.09333333333336,
330.1041666666667,
330.12083333333334,
330.1075,
330.09250000000003,
330.10083333333336,
330.11333333333334,
330.19166666666666,
330.3066666666666,
330.3691666666666,
330.40749999999997,
330.4458333333334,
330.50916666666666,
330.61083333333335,
330.6858333333333,
330.7525,
330.84999999999997,
330.94,
331.02916666666664,
331.12916666666666,
331.1983333333334,
331.30500000000006,
331.42333333333335,
331.5591666666667,
331.62333333333345,
331.67000000000013,
331.7625,
331.8233333333333,
331.8616666666667,
331.89166666666665,
331.95666666666665,
332.02666666666664,
332.11999999999995,
332.1558333333333,
332.28916666666663,
332.4058333333333,
332.59,
332.7725,
332.9233333333333,
333.08,
333.27416666666664,
333.48749999999995,
333.6791666666666,
333.84416666666664,
334.0325,
334.2066666666667,
334.34833333333336,
334.4775,
334.5683333333333,
334.72166666666664,
334.85583333333335,
335.0108333333333,
335.1,
335.19750000000005,
335.30583333333334,
335.41499999999996,
335.515,
335.63416666666666,
335.7683333333333,
335.8625,
335.96416666666664,
336.0683333333334,
336.15500000000003,
336.2633333333334,
336.3975000000001,
336.5466666666667,
336.6766666666667,
336.83583333333337,
336.9825,
337.12,
337.27000000000004,
337.4458333333334,
337.63,
337.805,
337.96416666666664,
338.1266666666666,
338.3166666666666,
338.47499999999997,
338.64,
338.7625,
338.87833333333333,
339.06250000000006,
339.19250000000005,
339.3316666666667,
339.4641666666667,
339.5625,
339.6766666666667,
339.7441666666667,
339.80249999999995,
339.87833333333333,
339.9841666666667,
340.1191666666667,
340.2558333333333,
340.3566666666666,
340.45166666666665,
340.565,
340.7091666666666,
340.8208333333334,
340.9541666666667,
341.10083333333336,
341.22,
341.3333333333333,
341.4058333333333,
341.4783333333334,
341.5316666666667,
341.61750000000006,
341.6675,
341.78749999999997,
341.9016666666667,
342.05833333333334,
342.21666666666664,
342.4058333333333,
342.57916666666665,
342.7558333333333,
342.9516666666666,
343.15333333333325,
343.3733333333333,
343.5508333333333,
343.74333333333334,
343.9075,
344.0441666666666,
344.1608333333333,
344.2833333333333,
344.38583333333327,
344.47999999999996,
344.59083333333325,
344.7175,
344.8675,
344.97333333333336,
345.0975,
345.2833333333333,
345.3908333333333,
345.5158333333333,
345.63999999999993,
345.7325,
345.8591666666667,
346.0158333333334,
346.1400000000001,
346.2583333333334,
346.3516666666667,
346.46,
346.5491666666667,
346.57750000000004,
346.6775,
346.7808333333334,
346.89166666666665,
347.00416666666666,
347.08,
347.2475,
347.37000000000006,
347.4941666666667,
347.60833333333335,
347.7708333333333,
347.8908333333333,
348.0208333333333,
348.14916666666664,
348.285,
348.41833333333335,
348.58166666666665,
348.75083333333333,
348.8491666666667,
349.0075,
349.16249999999997,
349.31166666666667,
349.46,
349.6916666666666,
349.9158333333333,
350.105,
350.2883333333334,
350.47999999999996,
350.69583333333327,
350.8866666666667,
351.0791666666667,
351.3,
351.49500000000006,
351.69000000000005,
351.90333333333336,
352.04749999999996,
352.1791666666666,
352.34999999999997,
352.48333333333335,
352.6133333333333,
352.7175,
352.83,
352.92333333333335,
353.0033333333334,
353.0975,
353.2050000000001,
353.2708333333333,
353.41,
353.5491666666667,
353.6041666666667,
353.7233333333333,
353.8025,
353.8725,
353.9741666666667,
354.08166666666665,
354.195,
354.32750000000004,
354.45250000000004,
354.5416666666667,
354.60166666666663,
354.73333333333335,
354.93249999999995,
355.0866666666666,
355.23999999999995,
355.3575,
355.4333333333334,
355.5133333333334,
355.57500000000005,
355.6375,
355.70416666666665,
355.8216666666667,
355.9375,
355.99083333333334,
356.02833333333336,
356.0683333333334,
356.1691666666666,
356.24000000000007,
356.325,
356.3808333333334,
356.46250000000003,
356.50666666666666,
356.54583333333335,
356.6091666666667,
356.6266666666667,
356.6783333333333,
356.69250000000005,
356.7416666666666,
356.7583333333334,
356.78333333333336,
356.8475,
356.94166666666666,
357.01,
357.10249999999996,
357.2149999999999,
357.31999999999994,
357.455,
357.58166666666665,
357.74583333333334,
357.8691666666667,
357.97749999999996,
358.14916666666664,
358.3016666666667,
358.445,
358.60999999999996,
358.7866666666667,
358.95916666666676,
359.0991666666667,
359.2625,
359.41833333333335,
359.59166666666664,
359.76250000000005,
359.96166666666664,
360.1508333333333,
360.2958333333333,
360.5008333333333,
360.66166666666663,
360.825,
360.9683333333333,
361.1483333333333,
361.345,
361.53666666666663,
361.6408333333333,
361.7591666666667,
361.90333333333336,
362.0625,
362.2475,
362.3616666666667,
362.49333333333334,
362.6125,
362.7433333333334,
362.83,
362.90083333333337,
362.9316666666666,
363.0816666666667,
363.2083333333333,
363.26416666666665,
363.3283333333334,
363.39916666666664,
363.46166666666664,
363.5666666666668,
363.7008333333333,
363.87750000000005,
364.0566666666667,
364.21416666666664,
364.44,
364.6316666666667,
364.8641666666667,
365.1475,
365.44083333333333,
365.7491666666667,
366.05916666666667,
366.35583333333335,
366.6075,
366.84,
367.08666666666664,
367.3516666666667,
367.55833333333334,
367.75500000000005,
367.88500000000005,
367.99583333333334,
368.13166666666666,
368.21166666666676,
368.2775,
368.3591666666666,
368.46,
368.53999999999996,
368.63166666666666,
368.6675,
368.74333333333334,
368.8125,
368.86499999999995,
368.9825,
369.01666666666665,
369.1175,
369.3008333333333,
369.4391666666666,
369.57666666666665,
369.7075,
369.81666666666666,
369.9816666666666,
370.1383333333333,
370.26916666666665,
370.4591666666667,
370.58666666666664,
370.72499999999997,
370.85083333333336,
370.95,
371.06916666666666,
371.18666666666667,
371.31916666666666,
371.4808333333333,
371.6208333333334,
371.76,
371.8966666666666,
372.055,
372.24583333333334,
372.45250000000004,
372.64000000000004,
372.855,
373.0316666666666,
373.23916666666673,
373.45250000000004,
373.6499999999999,
373.8541666666667,
374.0491666666667,
374.2766666666667,
374.51416666666665,
374.74500000000006,
374.97166666666675,
375.18333333333334,
375.385,
375.6000000000001,
375.8008333333334,
375.98333333333335,
376.15833333333336,
376.3441666666667,
376.54583333333335,
376.76416666666665,
376.93250000000006,
377.04999999999995,
377.1141666666667,
377.2475,
377.33833333333337,
377.4483333333333,
377.5725,
377.6983333333333,
377.82,
377.97499999999997,
378.1325,
378.29416666666674,
378.4475,
378.6583333333333,
378.9316666666666,
379.16166666666663,
379.36666666666673,
379.5799999999999,
379.7641666666666,
379.98333333333335,
380.2291666666667,
380.43666666666667,
380.5958333333333,
380.7891666666667,
381.00416666666666,
381.1575,
381.3008333333333,
381.44,
381.6191666666667,
381.79749999999996,
381.9483333333333,
382.09083333333336,
382.21750000000003,
382.36083333333335,
382.5233333333333,
382.6841666666666,
382.8141666666666,
382.9883333333333,
383.1616666666667,
383.29833333333335,
383.4783333333333,
383.6483333333333,
383.8441666666666,
384.0249999999999,
384.2483333333332,
384.41,
384.53249999999997,
384.5825,
384.74916666666667,
384.8875,
385.04416666666657,
385.2174999999999,
385.40166666666664,
385.555,
385.6975,
385.8308333333334,
385.94666666666666,
386.08333333333326,
386.31333333333333,
386.5158333333334,
386.6475,
386.78999999999996,
386.9258333333333,
387.09,
387.2183333333333,
387.33750000000003,
387.48916666666673,
387.6425,
387.78749999999997,
388.0133333333333,
388.2075,
388.45,
388.6875,
388.9108333333333,
389.09166666666664,
389.2791666666667,
389.45250000000004,
389.685,
389.90500000000003,
390.1016666666667,
390.31749999999994,
390.4541666666667,
390.5733333333333,
390.6375,
390.73749999999995,
390.8683333333334,
391.0608333333334,
391.21,
391.3975,
391.54416666666657,
391.6783333333333,
391.85083333333336,
392.0016666666667,
392.1675,
392.31666666666666,
392.56166666666667,
392.7716666666667,
392.935,
393.08833333333337,
393.2766666666667,
393.44666666666666,
393.6199999999999,
393.84666666666664,
394.05583333333334,
394.2616666666667,
394.5108333333333,
394.76666666666665,
394.955,
395.2124999999999,
395.45416666666665,
395.7,
395.93333333333334,
396.1333333333334,
396.35249999999996,
396.53249999999986,
396.73749999999995,
396.9258333333333,
397.0291666666667,
397.2166666666667,
397.4558333333334,
397.6175,
397.8358333333333,
397.9825000000001,
398.13166666666666,
398.2833333333333,
398.47166666666664,
398.6416666666666,
398.81249999999994,
398.99083333333334,
399.18083333333334,
399.3333333333333,
399.4866666666667,
399.6691666666666,
399.79750000000007,
399.98,
400.1408333333333,
400.33083333333326,
400.52500000000003,
400.76416666666665,
401.01250000000005,
401.2250000000001,
401.5333333333333,
401.81,
402.1641666666667,
402.47666666666663,
402.81166666666667,
403.0725,
403.35083333333336,
403.63500000000005,
403.9099999999999,
404.19750000000005,
404.41249999999997,
404.715,
404.9158333333333,
405.1225,
405.2575,
405.42333333333335,
405.5975,
405.8258333333333,
406.065,
406.26,
406.4291666666666,
406.5616666666667,
406.7583333333334,
406.90749999999997,
407.0625,
407.23333333333335,
407.3358333333333,
407.465,
407.62416666666667,
407.75499999999994,
407.9083333333333,
408.08666666666676,
408.2841666666666,
408.52583333333337,
408.715,
408.955,
409.2416666666666,
409.45750000000004,
409.715,
410.0,
410.26416666666665,
410.52,
410.7716666666667,
411.02583333333337,
411.23916666666673,
411.4283333333333,
411.6541666666665,
411.8691666666666,
412.06749999999994,
412.2808333333333,
412.5233333333333,
412.7275,
412.9308333333334,
413.1516666666667,
413.3683333333333,
413.59833333333336,
413.8283333333334,
414.04833333333323,
414.2383333333333,
414.39750000000004,
414.59833333333336,
414.8400000000001,
415.0566666666667,
415.2083333333333,
415.40333333333336,
415.5983333333333,
415.73916666666673,
415.88750000000005,
416.0891666666667,
416.2466666666667,
416.4508333333334,
416.67333333333335,
416.88416666666666,
416.9816666666666,
417.0800000000001,
417.23499999999996,
417.4058333333333,
417.56749999999994,
417.79416666666657,
418.0891666666667,
418.2466666666667,
418.4508333333333,
418.67333333333335,
418.8841666666667,
418.9816666666666,
419.0799999999999,
419.23499999999996,
419.4058333333333,
419.56750000000005,
419.79416666666674,
]

export default co2_mean